import { generate, type ToVariants } from '@/components/experiments/Core/generateBasicExperimentComponent';

// ?preferred_variant=SHORTS_EXP_V3:control
// ?preferred_variant=SHORTS_EXP_V3:variant_1
// ?preferred_variant=SHORTS_EXP_V3:variant_2
// ?preferred_variant=SHORTS_EXP_V3:variant_3

// ?remove_preferred_experiment=SHORTS_EXP_V3

export const ReelsExpName = 'SHORTS_EXP_V3' as const;

export type ReelsExpVariants = ToVariants<typeof ReelsExpVariants>;

export const ReelsExpVariants = {
	CONTROL: 'control',
	VARIANT_1: 'variant_1',
	VARIANT_2: 'variant_2',
	VARIANT_3: 'variant_3',
} as const;

export default generate(ReelsExpName, ReelsExpVariants);
